export const userApiUrl = {
  consultation: '/user/apis/unrestricted/consultation'
};

export const channelAccountApiUrl = {
  naverCaptcha: (organizationId: string, teamId: string) =>
    `/api/v1/organizations/${organizationId}/teams/${teamId}/channel-accounts/naver/captcha`
};
